import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {IApplication} from "../types/IApplication";

export const shouldApplicationPriceBeenShown = (application?: IApplication | null) => {
    if (application) {
        // IApplication["price_visibility"] is taken from the offer configuration - if offer.price_visibility is set to PriceVisibilityType.AUTO, then value will be taken from the vendor configuration.
        const priceVisibilityAlways = application.price_visibility === PriceVisibilityType.ALWAYS;
        const priceVisibilityAuto = application.price_visibility === PriceVisibilityType.AUTO;

        return priceVisibilityAlways || (priceVisibilityAuto && application.show_price);
    }

    return false;
};
import {PriceVisibilityType} from "../../vendor/types/PriceVisibilityType";
import {IApplication} from "../types/IApplication";

export const shouldApplicationPriceBeenShown = (application?: IApplication | null) => {
    if (application) {
        // IApplication["price_visibility"] is taken from the offer configuration - if offer.price_visibility is set to PriceVisibilityType.AUTO, then value will be taken from the vendor configuration.
        const priceVisibilityAlways = application.price_visibility === PriceVisibilityType.ALWAYS;
        const priceVisibilityAuto = application.price_visibility === PriceVisibilityType.AUTO;

        return priceVisibilityAlways || (priceVisibilityAuto && application.show_price);
    }

    return false;
};
